import React, { useEffect, useState } from 'react';
import Footer from '../Shared/Footer/Footer';
import Header from '../Shared/Header/Header';
import { Box, Button, Container, Grid, Paper, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import GitHubIcon from '@mui/icons-material/GitHub';
import LanguageIcon from '@mui/icons-material/Language';

const ProjectDetails = () => {
    const [projects, setProjects] = useState([]);
    const [project, setProject] = useState({});
    const index = useParams().index;
    // console.log(index)
    useEffect(() => {
        fetch('https://raw.githubusercontent.com/mahadihassanriyadh/images/main/projects.json')
            .then(res => res.json())
            .then(data => {
                setProjects(data);

            })
    }, [])

    useEffect(() => {
        // console.log(projects)
        if (projects.length !== 0) {
            const project = projects.find(p => index == p.index)
            setProject(project);
        }
    }, [projects])
    

    
    return (
        <>
        <Header></Header>

            <Container sx={{ mt: 10 }}>
                <Paper sx={{ mb: 10, p: 5 }} elevation="12" style={{backgroundColor: '#212121', color: 'white'}} >
                    <Typography style={{textAlign: 'center', fontWeight: 600}} variant="h3" gutterBottom component="div">
                        { project?.name }
                    </Typography>
                    <Box style={{ marginBottom: 25, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }} style={{ width: "100%", display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <Grid item xs={12} sm={4} md={3}>
                                <Button style={{margin: 'auto', display: 'block', backgroundColor: 'black'}} className="btnGrad" variant="contained" ><a style={{ textDecoration: 'none', color: 'white', display: 'flex' }} href={project?.liveSite} target="_blank"><LanguageIcon sx={{mr: 1}} /> Live Site</a></Button>
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                                <Button style={{margin: 'auto', display: 'block', backgroundColor: 'black'}} className="btnGrad" variant="contained"><a style={{ textDecoration: 'none', color: 'white', display: 'flex'}} href={project?.clientSide} target="_blank"> <GitHubIcon sx={{mr: 1}}/> Client Side</a></Button>
                            </Grid>
                            {   project?.serverSide &&
                                <Grid item xs={12} sm={4} md={3}>
                                    <Button style={{margin: 'auto', display: 'block', backgroundColor: 'black'}} className="btnGrad" variant="contained"><a style={{ textDecoration: 'none', color: 'white', display: 'flex'}} href={project?.serverSide} target="_blank"> <GitHubIcon sx={{mr: 1}}/> Server Side</a></Button>
                                </Grid>
                            }
                        </Grid>
                    </Box>
                    <Typography style={{textAlign: 'left', fontWeight: 600}} variant="h5" gutterBottom component="div">
                        Project Details
                    </Typography>
                    <Typography style={{textAlign: 'left'}} variant="body1" gutterBottom component="div">
                        <ul>
                            {project?.description?.map(point => <li>{point}</li>)}
                        </ul>
                    </Typography>
                    <Typography style={{textAlign: 'left', fontWeight: 600}} variant="h6" gutterBottom component="div">
                    Technology Used:  
                    </Typography>
                    <Typography style={{textAlign: 'left'}} variant="body1" gutterBottom component="span">
                    {project.techUsed}
                    </Typography>
                </Paper>

                <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                    <Grid item xs={12}>
                        <img style={{width: "100%"}} src={project?.img?.[0]} alt="" />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <img style={{width: "100%"}} src={project?.img?.[1]} alt="" />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <img style={{width: "100%"}} src={project?.img?.[2]} alt="" />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <img style={{width: "100%"}} src={project?.img?.[3]} alt="" />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <img style={{width: "100%"}} src={project?.img?.[4]} alt="" />
                    </Grid>
                </Grid>
                
            </Container>
            
        <Footer></Footer>
        </>
    );
};

export default ProjectDetails;